import { render, staticRenderFns } from "./ConsolidationUnionHead.vue?vue&type=template&id=05742972&scoped=true"
import script from "./ConsolidationUnionHead.vue?vue&type=script&lang=js"
export * from "./ConsolidationUnionHead.vue?vue&type=script&lang=js"
import style0 from "./ConsolidationUnionHead.vue?vue&type=style&index=0&id=05742972&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05742972",
  null
  
)

export default component.exports